(function ($) {
	$.fn.fullScreenMenu = function(options) {

		function show_overlay() {
			$('#nm-widget-panel-overlay').addClass('show');
		}

		function hide_overlay() {
			$('#nm-widget-panel-overlay').addClass('fade-out');
			setTimeout(function(){
				$('#nm-widget-panel-overlay').removeClass('fade-out');
				$('#nm-widget-panel-overlay').removeClass('show');
			}, 500);
			
		}

		function open_search() {
			$('.' + options.menuSearchTrigger).addClass(options.menuSearchTrigger + '--open');
			$('body').addClass('mobile-search-open');
			show_overlay();
			$(options.menuSearchElement).slideDown(200, function(){
				$(options.menuSearchElement).find('input').focus();
			});
		}
		
		function close_search(do_hide_overlay, force_close) {
			$('.' + options.menuSearchTrigger).removeClass(options.menuSearchTrigger + '--open');
			if (typeof force_close !== 'undefined') {
				$('body').removeClass('mobile-search-open');
			}
			if (do_hide_overlay) {
				hide_overlay();	
			}
			$(options.menuSearchElement).slideUp(200, function(){
				$(options.menuSearchElement).find('input').blur();
				$('body').removeClass('mobile-search-open');
			});
		}

		function open_menu() {
			menuElement.scrollTop = 1;
			$('body').addClass('is-' + options.openBodyClass);
			$('body').addClass(options.openBodyClass);
			$('.' + options.menuElement).focus();	
			show_overlay();
		}

		function close_menu(do_hide_overlay, force_close) {
			menuElement.scrollTop = 1;
			$('body').removeClass(options.openBodyClass);
			if (typeof force_close !== 'undefined') {
				$('body').removeClass('is-' + options.openBodyClass);
			} else {
				setTimeout(function(){
					$('body').removeClass('is-' + options.openBodyClass);
				}, 500);
			}
			
			$('.' + options.menuElement).blur();
			if (do_hide_overlay) {
				hide_overlay();	
			}	
		}
		
		

		// Remove rubber effect
		var menuElement = document.querySelector('.' + options.menuElement);
		menuElement.addEventListener("touchstart", function() {
			var top = menuElement.scrollTop;
			var totalScroll = menuElement.scrollHeight;
			var currentScroll = top + menuElement.offsetHeight;

			if (top === 0) {
				menuElement.scrollTop = 1;
			} else if (currentScroll === totalScroll) {
				menuElement.scrollTop = top - 1;
			}
		});
		
		// Prevent scrolling on some cases
		document.ontouchmove = function (event) {
			if ($('body').hasClass(options.openBodyClass)) {
				var targets = $(event.target).parents().andSelf();
				if (!(targets.is('.' + options.menuElement)) || $(options.menuInnerElement).outerHeight(true) < menuElement.offsetHeight) {
					event.preventDefault();
				}
			}
		};
		
		// Toggler
		var toggleElement = $(options.toggleElement);		
		toggleElement.touchClick(function () {
			if ($('body').hasClass(options.openBodyClass)) {
				close_menu(true);
			} else {
				close_search(false);
				open_menu();
			}	
		});

		$('.' + options.menuNavElement + '__sub-menu').hide();

		var navItemToggle = $('.' + options.menuNavElement + '__toggle');
		navItemToggle.touchClick(function(elm){
			$(elm).toggleClass(options.menuNavElement + '__toggle--open');
			$(elm).parent().find('.' + options.menuNavElement + '__sub-menu').slideToggle(300);
		});

		var searchTrigger = $('.' + options.menuSearchTrigger);
		searchTrigger.touchClick(function(){
			if ($(options.menuSearchElement).is(":visible")) {
				close_search(true);
			} else {
				close_menu(false);
				open_search();
			}
		});

		var searchClose = $(options.menuSearchClose);
		searchClose.touchClick(function(){
			close_search(true);
		});

		var cart = $('#nm-mobile-menu-cart-btn');
		cart.touchClick(function(){
			close_menu(false, true);
			close_search(false, true);
		});
		
		var overlay = $('#nm-widget-panel-overlay');
		overlay.touchClick(function(){
			close_menu(false);
			close_search(false);
		});
	};
})(jQuery);